<ion-app>
    <app-header></app-header>
    <ion-content>
        <ion-router-outlet></ion-router-outlet>
    </ion-content>
    <app-footer></app-footer>
</ion-app>
